














import Vue from 'vue'
export default Vue.extend({
    computed: {
        languages: function (): {[key: string]: string} {
            const langs: {[key: string]: string} = this.$languages()
            delete langs[this.$locale()]
            return langs
        }
    }
})
